function openIncompatibleModal(hasIncompatible, hasNonstandard) {
  const modal = document.getElementById('incompatible-modal');
  const incompatibleItem = document.getElementById('incompatible-item');
  const nonstandardItem = document.getElementById('nonstandard-item');
  
  if (modal) {
    if (incompatibleItem) {
      incompatibleItem.style.display = hasIncompatible ? 'list-item' : 'none';
    }
    if (nonstandardItem) {
      nonstandardItem.style.display = hasNonstandard ? 'list-item' : 'none';
    }
    
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeIncompatibleModal() {
  const modal = document.getElementById('incompatible-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

function acknowledgeIncompatibleModal() {
  window.incompatibleModalAcknowledged = true;
  closeIncompatibleModal();
}

function hasAcknowledgedIncompatibility() {
  return window.incompatibleModalAcknowledged === true;
}

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('incompatible-modal-overlay')) {
    closeIncompatibleModal();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeIncompatibleModal();
  }
});
